import {
  AppBar,
  Avatar,
  Box,
  CircularProgress, 
  Menu,
  MenuItem,
  Toolbar,
  Typography,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery, useQueryClient } from "react-query"; 
import { getClinicianProfile } from "../../api/services/api";
import { icons, logo } from "../../assets";
import { StyledBadge } from "../styles";

const Appbar = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const queryClient = useQueryClient(); 
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const { data: profileData, isLoading, isError } = useQuery(
    ["clinician-profile"],
    getClinicianProfile
  );

  const clinician = profileData?.data;
  const userFullName = clinician?.user?.fullName || "User";
  const userImageUrl = clinician?.imageUrl;

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleClickLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("type");
    localStorage.removeItem("userId");
    queryClient.invalidateQueries(["clinician-profile"]); 
    queryClient.clear(); 
    handleCloseMenu();
    navigate("/login", { replace: true });
  };

  const handleClickProfile = () => {
    handleCloseMenu();
    navigate("/profile"); 
  };

  const handleClickLogo = () => {
    navigate("/dashboard");
  };

  const renderAvatarContent = () => {
    if (isLoading) {
      return <CircularProgress size={24} sx={{ color: 'white' }} />; 
    }
    if (isError || !clinician) {
      return <Avatar sx={{ bgcolor: theme.colors.primary.main }}>U</Avatar>; 
    }
    return (
      <Avatar
        onClick={handleMenu}
        alt={userFullName}
        src={userImageUrl || ""}
        sx={{
          bgcolor: !userImageUrl ? theme.colors.primary.main : undefined,
        }}
      />
    );
  };

  return (
    <>
      <AppBar color="inherit" position="fixed" sx={{ p: "10px 0 10px 25px" }}>
        <Toolbar
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{ cursor: "pointer", paddingLeft: "100px" }} 
            onClick={handleClickLogo}
          >
            <img src={logo} alt="Talaqah logo" width={70} height={65} />
          </Box>
          <Box
            mr={2}
            display="flex"
            // width="140px" 
            alignItems="center" 
            justifyContent="space-between"
          >
            <Box sx={{ cursor: "pointer" }}>
              <StyledBadge
                overlap="circular"
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                variant="dot" 
                onClick={handleMenu} 
              >
                {renderAvatarContent()}
              </StyledBadge>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right", 
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right", 
                }}
                open={Boolean(anchorEl)}
                onClose={handleCloseMenu}
              >
                <MenuItem onClick={handleClickProfile}>
                  <Box padding="5px" display="flex" alignItems="center">
                    <img src={icons.ProfileAvatar} alt="Profile icon" width={20} height={20} style={{ marginRight: theme.spacing(1) }} />
                    <Typography variant="subtitle2">
                      My Profile
                    </Typography>
                  </Box>
                </MenuItem>
                <MenuItem onClick={handleClickLogout}>
                  <Box padding="5px" display="flex" alignItems="center">
                    <img src={icons.Block} alt="Logout icon" width={20} height={20} style={{ marginRight: theme.spacing(1) }} />
                    <Typography variant="subtitle2">Logout</Typography>
                  </Box>
                </MenuItem>
              </Menu>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Appbar;
